import * as constants from './constants';
import http from '../../../utils/request';

const getAchData = (result) => ({
  type: constants.GET_FILTER_DATA,
  head: result.head,
  domain: result.searchList.domain,
  maturity: result.searchList.maturity,
  operation: result.searchList.operation,
  list: result.list,
  pageSum: result.pageSum
});

export const fetchAchData = (obj) => {
  return (dispatch) => {
    http('post', '/achieve/detail/lists', obj).then((res) => {
      // console.log('achieve', res.data);
      if (res.code === 200) {
        const result = res.data;
        dispatch(getAchData(result));
      }
    });
  }
}